<style scoped>
    #tabBar{
        padding:0rem 0rem 0rem 0rem;
    }
    #tabBar .tabBarLists{
        width:100%;
        display: flex;
        align-items: center;
        border-radius: 100rem;
    }
    #tabBar .tabBarLists .tabBarList{
        /* width:20%; */
        text-align: center;
        color:#fff;
        height: 2rem;
        line-height: 2rem;
        position: relative;
        font-size: 0.9rem;
    }
    #tabBar .tabBarLists .tabBarList img{
        height: 2rem;
        position: absolute;
        left: 0;
        z-index:99;
    }
    #tabBar .tabBarLists .tabBarList span{
        position: relative;
        z-index:100;
		color: #FFF;
        line-height: 2rem;
    }

    #tabBar .firstListView{
        /* position: fixed; */
        width: 250px;
        /* top:4.85rem; */
        /* margin-top:0rem; */
        background-color: #fff;
        /* z-index:999; */
    }

    #tabBar .firstListViewDiv{
        height: 4.4rem;
    }
    .stepLeft{
        border: 1px solid #e5e5e5;
        min-height: 300px;
        border-radius: 6px;
        margin-bottom: 20px;
    }
    .strip{
        border: 0.5px solid #e5e5e5;
        height: 60px;
        width: 1px;
        margin: 5px auto 7px;
    }
    .left_div{
        padding: 10px;
        border-bottom: 1px solid #e5e5e5;
    }
    .left_color div{
        color: #FFF;
    }
    .left_color{
        background: #3d7077;
    }
</style>
<style lang="scss">
	#tabBar{
        font-size: 0.75rem;
		.tabBarList{
			span{
				font-size: 0.88rem;
			}
		}
		.tabBarLists{
			.tabBarList{
				width: 25%;
			}
		}
	}
	
</style>
<template>
    <div id="tabBar">
        <div class="ListView firstListView" >
            <div class="stepLeft" style="background: #f0f7f0;">
                <!-- <img src="../../image/icon_vx1.png" alt=""> -->
                <!-- <img :src="b2"/>
                <div class="strip"></div>
                <img :src="keyIndex >= 2 ? b4 : b3"/>
                <div class="strip"></div>
                <img :src="keyIndex >= 3 ? b6 : b5"/>
                <div class="strip"></div>
                <img :src="keyIndex >= 4 ? b8 : b7"/>
                <div class="strip"></div>
                <img :src="keyIndex >= 5 ? b10 : b9"/> -->
                <div class="left_div" :class="{left_color:keyIndex == 1}" style="border-radius: 6px 6px 0 0;">
                    <div style="font-weight: 600;">{{$t('login.step')}} 1</div>
                    <div>{{$t('login.klzh')}}</div>
                </div>
                <div class="left_div" :class="{left_color:keyIndex == 2}">
                    <div style="font-weight: 600;">{{$t('login.step')}} 2</div>
                    <div>{{$t('login.khzl')}}</div>
                </div>
                <div class="left_div" :class="{left_color:keyIndex == 3}">
                    <div style="font-weight: 600;">{{$t('login.step')}} 3</div>
                    <div>{{$t('login.ywzk')}}</div>
                </div>
                <div class="left_div" :class="{left_color:keyIndex == 4}">
                    <div style="font-weight: 600;">{{$t('login.step')}} 4</div>
                    <div>{{$t('login.tzgk')}}</div>
                </div>
                <div class="left_div" :class="{left_color:keyIndex == 5}">
                    <div style="font-weight: 600;">{{$t('login.step')}} 5</div>
                    <div>{{$t('login.khsm')}}</div>
                </div>
                <div class="left_div" :class="{left_color:keyIndex == 6}">
                    <div style="font-weight: 600;">{{$t('login.step')}} 6</div>
                    <div>{{$t('login.fxpg')}}</div>
                </div>
                <div class="left_div" :class="{left_color:keyIndex == 7}" style="border:none;border-radius: 0 0 6px 6px;">
                    <div style="font-weight: 600;">{{$t('login.step')}} 7</div>
                    <div>{{$t('login.wskh')}}</div>
                </div>
            </div>
        </div>
        <!-- <div class="firstListViewDiv"></div> -->
    </div>
</template>
<script>

    export default {
        name: 'tabBar',
        data(){
            return{
                // bg1_01,bg1,bg2_01,bg2,bg3_01,bg3,
				b1:require('@/image/titleback/icon1.png'),
				b2:require('@/image/titleback/icon1_1.png'),

				b3:require('@/image/titleback/icon2.png'),
				b4:require('@/image/titleback/icon2_1.png'),

				b5:require('@/image/titleback/icon3.png'),
				b6:require('@/image/titleback/icon3_1.png'),
				b7:require('@/image/titleback/icon4.png'),
				b8:require('@/image/titleback/icon4_1.png'),
				b9:require('@/image/titleback/icon5.png'),
				b10:require('@/image/titleback/icon5_1.png'),
                keyIndex : this.$route.meta.keyIndex
            }
        },
        created(){
            console.log(this.keyIndex)
        },
        methods:{
            
        }
    }
</script>